import { render, staticRenderFns } from "./ImpersonateBanner.vue?vue&type=template&id=1170a120&scoped=true"
import script from "./ImpersonateBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonateBanner.vue?vue&type=script&lang=js"
import style0 from "./ImpersonateBanner.vue?vue&type=style&index=0&id=1170a120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1170a120",
  null
  
)

export default component.exports